import React from 'react';
import { Route } from 'react-router-dom';
import SupportTechnique from '../pages/Support/SupportTechnique';
import GuideUtilisateur from '../pages/Support/GuideUtilisateur';
import Confidentialite from '../pages/Privacy/Confidentialite';

/**
 * Éléments Route pages légales — à insérer comme enfants directs de <Routes>
 * ({publicLegalRouteElements}), pas via un composant wrapper.
 */
export const publicLegalRouteElements = (
  <>
    <Route path="/support" element={<SupportTechnique />} />
    <Route path="/support/guide" element={<GuideUtilisateur />} />
    <Route path="/privacy" element={<Confidentialite />} />
    <Route path="/confidentialite" element={<Confidentialite />} />
  </>
);
